import React, { useEffect, useState } from "react";
import _ from "lodash";
import { convertToNumber } from "@/helpers/validations";
import { checkIsNull, createS3Folder } from "@/helpers/common";
import { DEFAULT_MAP_ZOOM, IS_LAND } from "@/constants";
import { InventoryLotLandLocationForm } from "./InventoryLotLandLocationForm";
import { InventoryGeneralLocationsForm } from "./InventoryGeneralLocationsForm";
import GeoLocation from "@/components/Common/GeoLocation";
import InventoryLocationMap from "./InventoryLocationMap";

const Form = (props) => {

    const { propertyType, handleFormValues, formValues, isEditingProperty } = props

    const isLotLandPropertyType = propertyType === IS_LAND

    if (!propertyType) return null

    if (isLotLandPropertyType) return (
        <InventoryLotLandLocationForm
            handleFormValues={handleFormValues}
            formValues={formValues}
        />
    )

    return (
        <InventoryGeneralLocationsForm
            handleFormValues={handleFormValues}
            formValues={formValues}
            isEditingProperty={isEditingProperty}
        />
    )

}

export const InventoryLocationMapAndForm = (props) => {

    const {
        formValues,
        handleFormValues,
        isAgentCreated = false,
        mapType,
        locationError,
        sessionKey,
        propertyType,
        isEditingProperty = false,
    } = props

    const lat = _.get(formValues, "lat", null)
    const lng = _.get(formValues, "lng", null)
    const mapZoom = _.get(formValues, "mapZoom", null)
    const locationAddress = _.get(formValues, "locAddress", null)
    const validationErrors = _.get(formValues, "validationErrors", null)
    const s3Imagefolder = _.get(formValues, "s3ImageFolder", false)

    // to get the folder name
    useEffect(() => {
        if (!locationAddress) {
            const s3Folder = s3Imagefolder;
            if (!s3Folder) {
                getFolderName();
            }
        }
    }, [s3Imagefolder]);

    // Api call for get the folder name
    const getFolderName = async () => {
        const isWantAd = false;
        await createS3Folder(isWantAd).then(function (result) {
            const folderName = result;
            handleFormValues({ s3ImageFolder: folderName });
        });
    };

    const defaultProps = {
        center: {
            lat: convertToNumber(lat),
            lng: convertToNumber(lng),
        },
        zoom: mapZoom || DEFAULT_MAP_ZOOM,
    };


    const updateValuesToState = (key, value) => {
        if (!checkIsNull(value)) {
            handleFormValues({ [key]: value });
        } else {
            handleFormValues({ [key]: "" });
        }
    };

    return (
        <>
            {!locationAddress && !lat && !lng && (
                <GeoLocation handleFormValues={handleFormValues} />
            )}

            <InventoryLocationMap
                defaultProps={defaultProps}
                locationAddress={locationAddress}
                handleFormValues={handleFormValues}
                updateValuesToState={updateValuesToState}
                handlePropertyExist={({ isMapValidLocation }) => handleFormValues({ isMapValidLocation })}
                isAgentCreated={isAgentCreated}
                validationErrors={validationErrors}
                isPrivateRoom={false}
                mapType={mapType}
                locationError={locationError}
                sessionKey={sessionKey}
            />
            <Form
                propertyType={propertyType}
                handleFormValues={handleFormValues}
                formValues={formValues}
                isEditingProperty={isEditingProperty}
            />
        </>
    )
}